import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const InvoiceGateNewPage = lazy(() => import("@/features/invoice-gate/pages/invoice-gate-new"));

export const Route = createFileRoute("/(app)/dashboard/invoice-gate/new")({
  component: () => (
    <Suspense fallback={<div className="text-muted-foreground text-sm">Loading...</div>}>
      <InvoiceGateNewPage />
    </Suspense>
  ),
});
